import React from 'react'
import { kebabCase } from 'lodash'

import {
  ContentSwitcher,
  IProps as IContentSwitcherProps,
} from 'marketing-site/src/library/components/ContentSwitcher'
import {
  CONTENT_TYPE,
  IContentSwitcher as IContentfulContentSwitcher,
} from 'marketing-site/@types/generated/contentful'

import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'
import { IBrand, useBrand } from 'marketing-site/src/library/providers/brandProvider'

export const ContentfulContentSwitcher = (
  contentSwitcher: IContentfulContentSwitcher,
): React.ReactElement => {
  const brand = useBrand()
  return (
    <EntryMarker entry={contentSwitcher}>
      {() => <ContentSwitcher {...transformContentSwitcher(contentSwitcher, brand)} />}
    </EntryMarker>
  )
}

function transformContent(
  content:
    | IContentfulContentSwitcher['fields']['bodyA']
    | IContentfulContentSwitcher['fields']['bodyB'],
  brand: IBrand,
) {
  const filteredBody = content.map((item, index) => {
    const contentTypeId = item.sys.contentType?.sys.id as CONTENT_TYPE
    return renderTransformedComponent(contentTypeId, item, index, brand)
  })
  return filteredBody
}

const transformContentSwitcher = (
  { fields }: IContentfulContentSwitcher,
  brand: IBrand,
): IContentSwitcherProps => {
  return {
    ...fields,
    switchPosition:
      fields.switchPosition &&
      (kebabCase(fields.switchPosition) as IContentSwitcherProps['switchPosition']),
    labelA: fields.labelA || 'Scheme A',
    labelB: fields.labelB || 'Scheme B',
    bodyA: fields.bodyA && transformContent(fields.bodyA, brand),
    bodyB: fields.bodyB && transformContent(fields.bodyB, brand),
  }
}
